var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIcons.js
import * as React from 'react';
import IconContainer from '../IconContainer.js';

function RecurringIcon(props) {
  return /*#__PURE__*/React.createElement(IconContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.406 8.611C20.04 4.729 16.309 2.021 12.079 2h-.05v1.948c3.307 0 6.24 2.048 7.417 5.022l-1.94.356a.356.356 0 00-.132.65l3.571 2.329a.362.362 0 00.49-.09l2.496-3.442A.35.35 0 0024 8.567v-.002a.36.36 0 00-.426-.352l-2.168.398zm-9.378 11.146v1.949c3.512 0 6.692-1.784 8.507-4.77a.97.97 0 00-.333-1.338.986.986 0 00-1.348.331 7.924 7.924 0 01-6.826 3.828zm-9.17-8.39a.36.36 0 01.197.059l3.571 2.329a.356.356 0 01-.132.65l-1.876.344c1.183 2.962 4.126 5.008 7.41 5.008v1.949c-4.223 0-7.993-2.715-9.37-6.598l-2.232.41A.36.36 0 010 15.168v-.008a.35.35 0 01.069-.203l2.496-3.442a.36.36 0 01.292-.149zM12.027 2h-.024c-3.5.009-6.772 1.875-8.545 4.875a.965.965 0 00-.135.491v.002c0 .334.173.66.485.84a.986.986 0 001.343-.347 8.014 8.014 0 016.876-3.913V2z",
      fill: "currentColor"
    })))
  }));
}

export default RecurringIcon;